import { useContext } from 'react'

import { Auth0Context } from './auth0-context'
import type { Auth0ContextInterface } from '@auth0/auth0-react'

export function useAuth(): Auth0ContextInterface {
    const ctx = useContext(Auth0Context)
    if (!ctx) {
        throw new Error('useAuth must be used within Auth0ContextProvider')
    }
    return ctx
}
